import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["readonly"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-group errors" }

import { computed, reactive } from 'vue';
import { useEditModalCommon } from 'src/composables/useEditModalCommon';
import type { AdminGroup2 } from 'src/models/group2';
import type { AdminGroup3 } from 'src/models/group3';
import type { Lov } from 'src/models/master';
import type { AdminDeviceParams } from 'src/models/apis/device/adminDeviceRequest';
import type { DeviceInputModel } from 'src/models/device';
import { createDeviceInitInputModel } from 'src/models/device';
import { dtFormat } from 'src/lib/dateHelper';


export default /*@__PURE__*/_defineComponent({
  __name: 'DeviceEditModal',
  props: {
    isEditMode: { type: Boolean },
    device: {},
    availableGroups2: {},
    availableGroups3: {},
    carKinds: {},
    isRequesting: { type: Boolean },
    httpErrorMsgs: {}
  },
  emits: ["create", "update", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const state = reactive<{ device: DeviceInputModel }>({
  device: createDeviceInitInputModel(),
});

const { editModalTitle } = useEditModalCommon(props, () => props.device, (copied) => {
  state.device = copied;
});

const isDeviceIdInputReadonly = computed<boolean>(() => props.isEditMode);

const selectedGroup2 = computed<boolean>(() => {
  return state.device.group2Id != null;
});

const filteredGroups3 = computed<AdminGroup3[]>(() => {
  return props.availableGroups3.filter(group3 => group3.parentId === state.device.group2Id);
});

const validateDeviceForm = (device: DeviceInputModel): boolean => {
  if (!Number.isInteger(device.group2Id)) return false;
  if (!Number.isInteger(device.groupId)) return false;
  if (device.deviceId.length <= 0) return false;
  if (device.deviceId.length > 32) return false;
  if (device.carName.length <= 0) return false;
  if (!device.carKind) return false;
  if (device.bikou1 && device.bikou1.length > 250) return false;

  return true;
};

const isSaveButtonDisabled = computed<boolean>(() => {
  return props.isRequesting || !validateDeviceForm(state.device);
});

const toPayload = (): AdminDeviceParams => {
  return {
    device_id: state.device.deviceId,
    car_name: state.device.carName,
    car_kind: state.device.carKind ?? '',
    group2_id: state.device.group2Id ?? 0,
    group_id: state.device.groupId ?? 0,
    stopped_use_on: dtFormat(state.device.stoppedUseOn, 'yyyy/mm/dd'),
    bikou1: state.device.bikou1,
  };
};

const createDevice = (): void => {
  if (isSaveButtonDisabled.value) return;

  emit('create', toPayload());
};

const updateDevice = (): void => {
  if (isSaveButtonDisabled.value) return;

  emit('update', state.device.deviceId, toPayload());
};

const save = (): void => {
  if (props.isEditMode) {
    updateDevice();
  } else {
    createDevice();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_MyCalendar = _resolveComponent("MyCalendar")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: _unref(editModalTitle),
    "bottom-close-button-label": "保存",
    isCloseButtonDisabled: isSaveButtonDisabled.value,
    onClose: save,
    onDismiss: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-control-label" }, "事業所", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.device.group2Id) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (state.device.groupId = null))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availableGroups2, (e) => {
              return (_openBlock(), _createElementBlock("option", {
                key: e.id,
                value: e.id
              }, _toDisplayString(e.name), 9, _hoisted_2))
            }), 128))
          ], 544), [
            [_vModelSelect, state.device.group2Id]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-control-label" }, "部署", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.device.groupId) = $event)),
            disabled: !selectedGroup2.value
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGroups3.value, (e) => {
              return (_openBlock(), _createElementBlock("option", {
                key: e.id,
                value: e.id
              }, _toDisplayString(e.name), 9, _hoisted_5))
            }), 128))
          ], 8, _hoisted_4), [
            [_vModelSelect, state.device.groupId]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-control-label" }, " 車載器ID ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.device.deviceId) = $event)),
            readonly: isDeviceIdInputReadonly.value
          }, null, 8, _hoisted_7), [
            [_vModelText, state.device.deviceId]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-control-label" }, " 車両番号 ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.device.carName) = $event))
          }, null, 512), [
            [_vModelText, state.device.carName]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-control-label" }, "車種", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.device.carKind) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.carKinds, (e) => {
              return (_openBlock(), _createElementBlock("option", {
                key: e.key,
                value: e.key
              }, _toDisplayString(e.val), 9, _hoisted_10))
            }), 128))
          ], 512), [
            [_vModelSelect, state.device.carKind]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-control-label" }, " 利用停止日 ", -1)),
          _createVNode(_component_MyCalendar, {
            class: "stopped-use-on-date",
            "date-value": state.device.stoppedUseOn,
            onDateInput: _cache[6] || (_cache[6] = ($event: any) => (state.device.stoppedUseOn = $event))
          }, null, 8, ["date-value"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-control-label" }, "備考", -1)),
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control",
            maxlength: "250",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((state.device.bikou1) = $event))
          }, null, 512), [
            [_vModelText, state.device.bikou1]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.httpErrorMsgs, (e, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "error",
              key: `h-${i}`
            }, _toDisplayString(e), 1))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "isCloseButtonDisabled"]))
}
}

})